
import React, {FC} from 'react';
import {PostCardProps} from 'components/blog/PostCard';
import {GatsbyImage} from 'gatsby-plugin-image';

import * as styles from './styles.module.scss';

const Post: FC<PostCardProps> = ({slug, title, image}) => {
	const link = `/blog/post/${slug}`;
	return (
		<a className={styles.post} href={link} target='_blank' rel='noreferrer'>
			<GatsbyImage className={styles.image} {...image} />
			<div className={styles.title}>{title}</div>
		</a>
	);
};

export default Post;
